import api from "../api/services";

// utils/auth.ts
const tokenName = import.meta.env.VITE_TOKEN_NAME;
export function getToken() {
    return localStorage.getItem(tokenName);
}

function decodedToken(token) {
    return JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
}

export function getTokenDetail(infoType = "") {
    const decodeToken = decodedToken(getToken());
    let detail = decodeToken;
    if (infoType) {
        detail = decodeToken[infoType]
    }
    return detail;
}

export function isJwtExpired(token) {
    try {
        // JWT format: header.payload.signature (payload is base64url)
        const payload = decodedToken(token);
        // exp is in seconds
        const now = Math.floor(Date.now() / 1000);
        return typeof payload.exp === "number" ? payload.exp <= now : true;
    } catch {
        return true; // invalid token format => treat as expired
    }
}

export function isAuthenticated() {
    const t = getToken();
    if (!t || t?.trim() === "") return false;
    return !isJwtExpired(t);
}

export function handleLogout(redirect = true) {
    localStorage.removeItem(tokenName);
    delete api.defaults.headers.common["Authorization"];
    if (redirect) {
        window.location.replace("login");
    }
}

export function handleLogin(navigate = null, token = "") {
    if (!token) return
    localStorage.setItem(tokenName, token);
    // redirect to dashboard after successful login
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    if (navigate && typeof navigate === "function") {
        navigate('/dashboard');
    }
};